import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DirtyWildGameModuleConfig} from "../DirtyWildGameModuleConfig";
import {DirtyWildsSoundConfig} from "../DirtyWildsSoundConfig";
import {DirtyWildsRandomFeatureEvent} from "../features/DirtyWildsRandomFeatureReelStopController";
import {DirtyWildsTeaseEvent} from "../features/DirtyWildsRandomTeaseController";
import {DirtyWildGameMode} from "../features/DirtyWildsRespinZeroBetController";
import {DirtyWildsRFSyncEvent} from "../features/DirtyWildsRFSyncController";
import {DirtyWildsModeData} from "../server/data/DirtyWildsModeData";
import {DirtyWildsParsedGameData, WildSymbolData} from "../server/data/DirtyWildsParsedGameData";
import {DirtyWildsParsedInitData} from "../server/data/DirtyWildsParsedInitData";

/**
 * Class description
 *
 * Created: 2018-04-27
 * @author jonas
 */
export class DirtyWildsReels extends Reels {

    private _isRandomFeatureTriggered:boolean;
    private _isRandomSyncFeatureTriggered:boolean;
    private _isEventCompleted:boolean;
    private _doRandomQuickAnimate:boolean;
    private _isTeaseInitiated:boolean;
    private _positionsWildInfo:WildSymbolData[] = [];
    private _previousOverlaySymbols:WildSymbolData[] = [];

    constructor() {
        super();

        DirtyWildGameModuleConfig.reelAreaController = this;
        this._isEventCompleted = false;
    }

    protected onGameDataParsed(data:ParsedGameData):void {
        this._isTeaseInitiated = false;
        this._isEventCompleted = false;
        this._isRandomFeatureTriggered = (<DirtyWildsParsedGameData>data).isRandomFeatureTriggered;
        this._isRandomSyncFeatureTriggered = (<DirtyWildsParsedGameData>data).isRandomSyncFeatureTriggered;
        this._positionsWildInfo = (<DirtyWildsParsedGameData>data).positionsWildInfo;
    }

    protected onInitDataParsed(data:DirtyWildsParsedInitData):void {
        this._positionsWildInfo = (<DirtyWildsParsedInitData>data).positionsWildInfo;
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, DirtyWildsRFSyncEvent.SET_EVENT_VARIABLE, (event:GameEvent) => this.setEventCompleted(event.params[0]));
        EventHandler.addEventListener(this, DirtyWildsTeaseEvent.TEASE_INITIATED, (event:GameEvent) => this.setTeaseVariable());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, DirtyWildsRandomFeatureEvent.RANDOM_QUICK_ANIMATE, (event:GameEvent) => this.setDoRandomQuickAnimate(event.params[0]));
    }

    protected onBeforeSpinStart():void {
        super.onBeforeSpinStart();
        //This happens before  we get new data from server. The effect is that we use data from perv spin.
        if(DirtyWildsModeData.instance.nextMode == DirtyWildGameMode.STICKY_RESPIN) {
            this._previousOverlaySymbols = this._positionsWildInfo;
        }
    }

    private setEventCompleted(value:boolean):void {
        this._isEventCompleted = value;
    }

    private setDoRandomQuickAnimate(value:boolean):void {
        this._doRandomQuickAnimate = value;
    }

    private setTeaseVariable():void {
        this._isTeaseInitiated = true;
    }

    // Added fastSpin because sometime the fastSpin can be canceled by features.
    protected onStopSpin(stopData:{ quickStop:boolean, fastSpin:boolean }):void {
        if(this._isRandomSyncFeatureTriggered || this._isRandomFeatureTriggered || this._isTeaseInitiated) {
            if(this._isEventCompleted) {
                super.onStopSpin(stopData);
            }
        } else {
            super.onStopSpin(stopData);
        }
    }

    public checkForOverLays(reelId:number):boolean {
        return (this._previousOverlaySymbols.filter((a) => {return a.wildPosition[0] === reelId}).length > 2);
    }

    public getFirstNearWinReel(reelId:number):number {
        if(this._isRandomFeatureTriggered) {
            return 2;
        } else {
            if(this.checkForOverLays(reelId)) {
                return -1;
            }
            return [1, 2, 3].indexOf(reelId);
        }
    }

    protected onReelBounceStarted(stopData:IReelStoppedData):void {
        // If not special bounce sound by feature, play the default sound.
        if(this._isRandomSyncFeatureTriggered) {
            if([0, 1, 4].indexOf(stopData.reelId) > -1) {
                SlotGame.sound.playEffect(DirtyWildsSoundConfig.SYNC_LANDING);
            }
        } else if((stopData.quickStop && [0, 4].indexOf(stopData.reelId) > -1) || !stopData.quickStop) {
            SlotGame.sound.playEffect(DirtyWildsSoundConfig.DIRTYWILDS_REELS_DEFAULT_BOUNCE[stopData.reelId]);
        }

        let lastActiveReel = this._activeReels.lastIndexOf(true);

        if(this._isRandomFeatureTriggered) {
            lastActiveReel = 2;
        }

        if(DirtyWildsModeData.instance.mode == DirtyWildGameMode.STICKY_RESPIN) {
            lastActiveReel = 3;
        }

        if(lastActiveReel != -1 && lastActiveReel == stopData.reelId) {
            this.stopSpinSounds();
        }
    }

    protected startSpinSounds():void {
        super.startSpinSounds();
        SlotGame.sound.playEffect(DirtyWildsSoundConfig.DIRTYWILDS_REELS_SPINNING, 2000);
        // DirtyWildGameModuleConfig.soundPlayer.startCountUp();
    }

    protected stopSpinSounds():void {
        super.stopSpinSounds();
        SlotGame.sound.stopEffect(DirtyWildsSoundConfig.DIRTYWILDS_REELS_SPINNING);
    }
}